import { render, staticRenderFns } from "./PaymentResultView.vue?vue&type=template&id=94ce302a&scoped=true&"
import script from "./PaymentResultView.vue?vue&type=script&lang=js&"
export * from "./PaymentResultView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResultView.vue?vue&type=style&index=0&id=94ce302a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ce302a",
  null
  
)

export default component.exports